<template>
  <DisplayHtmlDangerously
    class="richtext px-5"
    :class="{ 'mb-10': withMargin, 'richtext--no-inner-margin': withNoInnerMargins }"
    :html-text="markdownText"
  />
</template>

<script lang="ts">
import parseMarkdown from '~~/helpers/parseMarkdown';
import DisplayHtmlDangerously from '~/components/atoms/DisplayHtmlDangerously/DisplayHtmlDangerously.vue';

export default defineComponent({
  name: 'RichText',
  components: {
    DisplayHtmlDangerously,
  },
  props: {
    richText: {
      type: String,
      default: () => '',
    },
    withMargin: {
      type: Boolean,
      default: true,
    },
    withNoInnerMargins: {
      type: Boolean,
      default: false,
    },
    autoRenderEmail: {
      type: [Boolean, String],
      default: true,
    },
  },
  setup(props) {

    const isAutoRenderEmailEnabled = computed(() => {

      if (typeof props.autoRenderEmail === 'string') {

        return props.autoRenderEmail.toLowerCase() !== 'false';

      }

      return props.autoRenderEmail;

    });

    const markdownText = computed(() => parseMarkdown(props.richText, {
      autoRenderEmail: isAutoRenderEmailEnabled.value,
    }));

    return {
      markdownText,
    };

  },
});
</script>

<style lang="scss" scoped>
.richtext :deep() {
  h1 {
    margin-bottom: 18px;

    @apply text-EXPONDO-black;
  }

  h2 {
    @apply text-EXPONDO-black text-xl font-bold lg:text-3xl;

    margin-bottom: 12px;
    line-height: 3rem;
  }

  h3 {
    margin-bottom: 8px;

    @apply text-EXPONDO-black;
  }

  h4 {
    margin-bottom: 4px;

    @apply text-EXPONDO-black;
  }

  h5,
  h6 {
    margin-bottom: 4px;

    @apply text-EXPONDO-black;
  }

  p,
  ul,
  ol {
    margin-bottom: 18px;
  }

  ul {
    list-style-position: inside;
    text-indent: -1em;
    padding-left: 3.2em;
  }

  ol {
    list-style-position: inside;
  }

  a {
    @apply text-EXPONDO-secondary underline;

    text-decoration-thickness: 1px;
    overflow-wrap: break-word;
  }
}

.richtext--no-inner-margin :deep() {
  p,
  ul,
  ol {
    margin-bottom: 0;
  }
}
</style>
